<script>
import Swal from "sweetalert2";
import PartnerApi from "@/services/partner-api";
import PartnerZone from "@/router/views/zone/partner-zone-component";

export default {
  name: 'partner',
  components: { PartnerZone},


  props:{
    countryId :{
        type:Number,
        default: null
    },
    citiesId :{
        type:Array,
        default:() => null
    },
    sectorList :{
        type:Array,
        default:() => null
    },
    nearsList :{
        type:Array,
        default:() => null
    },
    fromMenu:{
        type:Boolean,
        default:false
    },
    partnerStatus:{
        type:String,
        default:null
    }
    },
  data() {
    return {

      partnersCsvFile: null,
      partnersCsvFileImportInProgress: false,
      itemsCsvFailures: null,

      partners:[],
      isLoadingPartners: false,
      pagemodel: {currentPage : 1, perPage :this.fromMenu ? 10 : 5, totalRows: 0},

      showCartModal:false,
      selectedPartner: null,


      partnerFields: [
        { key:"companyName", label: "", sortable: false,thClass:"text-left" , tdClass:" font-size-16 text-uppercase p-2 font-weight-bold text-left align-middle"},
        { key:"ownerName", label: "", sortable: false,thClass:"text-left" , tdClass:"font-size-14 text-left align-middle"},
        { key:"purchasingPower", label: "", sortable: false,thClass:"text-center" , tdClass:"text-center align-middle"},
        { key:"phone", label: "", sortable: false,thClass:"text-left" , tdClass:"text-left align-middle"},
        { key:"shortAddress", label:"", thClass:"text-left", tdClass:"text-left align-middle", thStyle:"min-width:150px;"}, 
        { key:"sector", label: "", sortable: false,thClass:"text-left", tdClass:"text-left font-weight-bold  align-middle"},
        { key:"dayOffAsString", label: "", sortable: false,thClass:"text-center" , tdClass:"text-center align-middle"},
        { key:"gps", label: "", sortable: false,thClass:"text-center" , tdClass:"text-center font-weight-bold  align-middle", thStyle:"min-width:140px;"},
        { key:"status", label: "", sortable: false,tdClass:"text-center font-weight-bold  align-middle"},
        {key:"actions", label: "", tdClass:"text-center align-middle"},

      ],

     
    };
  },

  computed: {
    filters() {
        return {
        countryId: this.countryId,
        citiesId: (this.citiesId || []).map(item => item.id),
        sectorList: (this.sectorList || []).map(item => item.code),
        nearsList: (this.nearsList || []).map(item => item.code),
        partnerStatus: this.partnerStatus,
        };
    }
    },
    watch: {
        filters: {
            handler() {
                this.findPartner();
            },
            deep: true, 
        }
    },

  mounted(){

  },

  methods:{
    getColorFromShortCode(shortCode) {
        switch (shortCode) {
        case 'IN':
            return 'secondary'; // Inactive
        case 'Y':
            return 'success';   // Active
        case 'M':
            return 'info';      // Membership Request
        case 'N':
            return 'danger';    // Refusal
        case 'L':
            return 'warning';   // Contact Again
        case 'R':
            return 'dark';      // Partner Unknown Contact
        case 'S':
            return 'primary';   // Bakery Shop
        case 'RS':
            return 'light';     // Review Strategically
        default:
            return 'secondary'; // Default color
        }
    },
    
    deletePartner(partner){

        if(partner == null){
            return
        }

        Swal.fire({
            title: "Supprimer partenaire !",
            html: `<div class='text-info text-uppercase font-size-22'>${partner.companyName}</div>`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#d11010",
            confirmButtonText: "Oui, supprimer",
            cancelButtonText: "Annuler",
            }).then((result) => {
            if (result.value) {
                PartnerApi.deletePartner(this.pagemodel.currentPage, this.pagemodel.perPage, partner.id).then(
                    response => {
                        if(response) {
                        this.partners= response.partnerResponseDTO.list
                        this.pagemodel.totalRows = response.partnerResponseDTO.total;
                        this.pagemodel.currentPage = response.partnerResponseDTO.page;
                        this.pagemodel.perPage = response.partnerResponseDTO.pageSize;
                        this.pagemodel.pageSize = response.partnerResponseDTO.pageSize;
                    }   
                    }
                )
            }
            });
        },
    getIcon(status){
      switch(status){
        case 0: return 'disabled.svg';
        case 1: return 'active.svg';
        case 2:return 'stopwatch.svg';
      }
    },

    showInCart(partner){
        this.showCartModal = true
        this.selectedPartner= partner
    },

    findPartner(){
    this.isLoadingPartners = true

    PartnerApi.findPartner(this.pagemodel.currentPage, this.pagemodel.perPage, this.filters).then(result => {
        if (result) {
            this.partners = result.partnerResponseDTO.list;
            this.pagemodel.totalRows = result.partnerResponseDTO.total;
            this.pagemodel.currentPage = result.partnerResponseDTO.page;
            this.pagemodel.perPage = result.partnerResponseDTO.pageSize;
            this.pagemodel.pageSize = result.partnerResponseDTO.pageSize;
            this.isLoadingPartners = false

            this.$emit("refrechCountSelected", result.selectedCitiesCount , result.selectedSectorCount);


        }
    });
    }, 
  }

  
};
</script>


<template>
      <div class=" p-sm-4 p-0 mt-3 ">

                <div  class="table-responsive mb-0 mt-5" :style="{ minHeight: fromMenu ? '31em' : '15rem' }">
                    <b-table
                    :busy="isLoadingPartners"
                    :striped="true"
                    :small="true"
                    :hover="true"
                    :items="partners"
                    :fields="partnerFields"
                    :perPage="pagemodel.perPage"
                    thead-style="display: none"
                    responsive
                    >
                    <template v-slot:table-busy>
                    <div class="text-center my-2">
                        <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                    </div>
                    </template>
                    <template v-slot:head(gps)>
                        {{ $t("partner.table.head.gps") }} 
                    </template>
                    <template v-slot:head(companyName)>
                        {{ $t("partner.table.head.namePartner") }} 
                    </template>
                    <template v-slot:head(ownerName)>
                        {{ $t("partner.table.head.ownerName") }} 
                    </template>
                    <template v-slot:head(sector)>
                        {{ $t("partner.table.head.sector") }} 
                    </template>
                    <template v-slot:head(shortAddress)>
                        {{ $t("partner.table.head.shortAddress") }} 
                    </template>
                    <template v-slot:head(dayOffAsString)>
                        {{ $t("partner.table.head.dayOf") }} 
                    </template>
                    <template v-slot:head(phone)>
                        {{ $t("partner.table.head.phone") }} 
                    </template>
                    <template v-slot:head(purchasingPower)>
                        {{ $t("partner.table.head.purchasingPower") }} 
                    </template>
                    <template v-slot:head(active)>
                        {{ $t("partner.table.head.active") }} 
                    </template>

                    <template v-if="fromMenu" v-slot:head(status)>
                       {{ $t("partner.table.head.status") }}
                    </template>

                    <template v-slot:cell(purchasingPower)="{ value }">
                        <b-badge v-if="value && value > 0" href="#" :variant="value <= 3 ? 'danger' : value > 3 && value <= 6 ? 'success' : 'primary'" class="font-size-12 font-weight-bold pr-2 pl-2">
                            {{ value }}
                        </b-badge>
                        <div v-else>-</div>
                    </template>
                    <template v-slot:cell(phone)="{item}">
                        <div>{{item.phone1}}  {{ item.phone2 ? ("/"+ item.phone2 ): "" }}</div>
                    </template>
                    <template v-slot:cell(dayOffAsString)="{value}">
                        <div>{{value ? value  : "-"}}</div>
                    </template>

                    <template v-slot:cell(shortAddress)="{item}">
                        <div>{{item.countryName}} - {{ item.cityName }}</div>
                    </template>
                    <template v-slot:cell(gps)="{item}">
                        <code>{{item.latitude}} - {{ item.longitude }}</code>
                    </template>

                    <template v-slot:cell(status)="{ item }">
                        <div v-if="fromMenu" class="d-flex justify-content-center align-items-center">
                            <a v-if="item.partnerStatusDTO" :title="item.partnerStatusDTO.description">
                            <b-badge 
                                :variant="getColorFromShortCode(item.partnerStatusDTO.shortCode)" 
                                class="font-size-12 font-weight-bold px-2">
                                {{ item.partnerStatusDTO.shortCode || 'N/A' }}
                            </b-badge>
                            </a>
                        </div>
                    </template>




                    <template v-slot:cell(actions)="{ item }">
                    <div v-if="fromMenu" class="d-flex justify-content-center align-items-center">



                        <b-button  @click="showInCart(item)" title="Afficher sur la carte"  size="sm"  class="bg-light mr-4" variant="outline-secondary" >
                            <img
                            alt="View details"
                            width="20px"
                            src="@/assets/icons/find-location.svg"
                            style="cursor: pointer; "/>                        
                        </b-button> 

                        <router-link  :to="{ path: '/partenaire', query: { partnerId: item.id } }"  >
                            <b-button  @click="showInCart(item)" title="Modifier"  size="sm"  class="bg-light mr-2" variant="outline-secondary" >
                                <img
                                    alt="Edit partner"
                                    width="20px"
                                    src="@/assets/icons/pencil.svg"
                                    style="cursor: pointer;"
                                />                    
                            </b-button> 
                        </router-link>

                            <b-button  @click="deletePartner(item)" title="Modifier"  size="sm"  class="bg-light mr-3" variant="outline-secondary" >
                                
                        <img
                            alt="Delete partner"
                            width="20px" 
                            src="@/assets/icons/trash.svg"
                            style="cursor: pointer;"/>                 
                            </b-button> 
                       
                    </div>
                </template>

                    </b-table>
                    <span v-if="!isLoadingPartners && partners && !partners.length" class="d-flex justify-content-center m-4 text-danger" >{{$t("reporting.supplier.emptyTable") }} </span>
                </div>
                <!-- Pagination -->
                 <div class="row pt-3 pl-2 mb-lg-0 mb-sm-4">
                    <div class="col-sm-8">
                        <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                            <b-form-select @input="findPartner()"  v-model="pagemodel.perPage" size="sm" style="width: 5em" :options="[5,10,50,100]"></b-form-select>
                            <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{pagemodel.totalRows}} {{ $t("pagination.lines") }}</span></div>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="dataTables_paginate paging_simple_numbers float-right">
                            <ul class="pagination pagination-rounded mb-0">
                            <b-pagination v-model="pagemodel.currentPage" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="findPartner()" :disabled="isLoadingPartners" ></b-pagination>
                            </ul>
                        </div>
                    </div>
                </div>  
                <!-- Fin Pagination  --> 

                <b-modal v-model="showCartModal" centered  hide-footer hide-header size="md" >
                    <div class="row pb-3">
                        <div class="col-7"> 
                            <h5 class="text-dark p-0 text-left text-uppercase font-weight-bold "> {{ selectedPartner ? selectedPartner.companyName : "" }} </h5>
                            <span class="text-dark text-uppercase"> {{ selectedPartner ? selectedPartner.address : "" }} </span>
                        </div>

                        <div class="col-5 text-right">
                            <code class=" p-2 text-left text-uppercase font-weight-bold "> {{ selectedPartner ? "["  +  selectedPartner.latitude + ', ' + selectedPartner.longitude + "]"  : "" }} </code>
                        </div>
                    </div>
                    <PartnerZone :partner="selectedPartner" />
                </b-modal>

      </div>
  
         
  </template>
  

  <style scoped>
  .custom-border {
    border: 1px dashed #cccccc;
    border-radius: 4px;
    padding: 16px;
    }

  </style>
